import React, { useState } from "react";
import SubRows from "./SubRows";
import lc from "../cmprtbl.module.scss";

function BodyGroup( { rowData } ) {
    const [display, setDisplay] = useState( 'none' );

    return (
        <div className={ lc.body_group }>
            <button className={ lc.button_row } type="button" onClick={ () => setDisplay( ( display === 'none' ) ? 'block' : 'none' ) }>
                <div className={ lc.tr }>
                    <div className={ lc.th }>
                        <span className={ ( display === 'none' ) ? lc.toggle_icon_plus : lc.toggle_icon_minus }></span>
                        <span>{ rowData.name }</span>
                    </div>
                    
                    <div className={ lc.tr }>
                        { rowData.levels.map( ( value, levelIndex ) => (
                            <div className={ lc.td } key={ levelIndex }>
                                <span className={ ( value !== 0 ) ? ( ( value === 1 ) ? lc.level_icon_yes : lc.level_icon_optional ) : lc.level_icon_no }></span>
                            </div>
                        ) ) }
                    </div>
                </div>
            </button>

            <SubRows style={ { display } } data={ rowData } />
        </div>
    );
}

export default BodyGroup;
